export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div className="lg:col-span-1">
              <span className="text-2xl font-heading font-black text-primary-400 tracking-tight whitespace-nowrap">
                黑料大赛
              </span>
              <p className="mt-4 text-sm text-background-400 leading-relaxed">
                黑料大赛📢吃瓜现场，实时追踪网红撕逼、明星丑闻等最新八卦事件。汇聚全网热门话题，打造最全吃瓜合集，让每一位吃瓜群众不错过任何精彩瞬间。
              </p>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-background-50 mb-4">快速导航</h3>
              <div className="flex flex-col gap-2">
                {[
                  { label: '话题热榜', href: '#topics' },
                  { label: '专题合集', href: '#index' },
                  { label: '瓜友热评', href: '#comments' },
                  { label: '焦点深扒', href: '#carousel' },
                  { label: '实时快讯', href: '#updates' },
                  { label: '热搜风云榜', href: '#ranking' },
                ].map((item) => (
                  <a
                    key={item.href}
                    href={item.href}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {item.label}
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-background-50 mb-4">关于我们</h3>
              <div className="flex flex-col gap-2">
                {[
                  { label: '关于本站', href: '#about' },
                  { label: '爆料投稿', href: '#contact' },
                  { label: '吃瓜必读', href: '#faq' },
                  { label: '视频吃瓜', href: '#media' },
                  { label: '随身吃瓜', href: '#app' },
                ].map((item) => (
                  <a
                    key={item.href}
                    href={item.href}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {item.label}
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h3>
              <p className="text-sm text-background-500 leading-relaxed">
                与各大娱乐媒体、自媒体平台保持内容合作，持续为吃瓜群众带来第一手八卦资讯。合作品牌持续扩充中。
              </p>
              <div className="mt-4 flex items-center gap-3">
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-400 text-sm cursor-pointer hover:bg-primary-500 hover:text-background-50 transition-colors">
                  <i className="ri-weibo-line"></i>
                </span>
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-400 text-sm cursor-pointer hover:bg-primary-500 hover:text-background-50 transition-colors">
                  <i className="ri-wechat-line"></i>
                </span>
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-400 text-sm cursor-pointer hover:bg-primary-500 hover:text-background-50 transition-colors">
                  <i className="ri-tiktok-line"></i>
                </span>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 黑料大赛 — 吃瓜现场直击。本站内容仅供娱乐，不构成任何建议。
            </p>
            <p className="text-xs text-background-600">
              实时八卦 · 网红撕逼 · 明星丑闻 · 吃瓜合集
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}